import { IconChecklist, IconClock, IconExternalLink, IconMapPin, IconTruckDelivery } from '@tabler/icons';

import {
  Button,
  Modal,
  ModalBody,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '#root/components/ui';
import styles from './provinceDialog.module.scss';

interface ProvinceDialogProps {
  open: boolean;
  onClose: () => void;
}

const OFFICES = [
  {
    name: 'MBE Panamá',
    address: 'Av. República de Panamá 6297, Miraflores',
    map: 'https://maps.app.goo.gl/XtnnJAhzrbzJf5uc9',
  },
  {
    name: 'MBE Miraflores',
    address: 'Calle Berlín 219, Miraflores',
    map: 'https://goo.gl/maps/ehbT1nqisAz4gzTd9',
  },
  {
    name: 'MBE San Isidro',
    address: 'Las Begonias 774, San Isidro',
    map: 'https://goo.gl/maps/Bvy8W4c2LU82HF3f8',
  },
  {
    name: 'MBE Surco',
    address: 'Av. Primavera 1314, Santiago de Surco',
    map: 'https://goo.gl/maps/LexVPchqLSyFqwvr5',
  },
];

/**
 * Cómo entregar un acuerdo con Envío Nacional: oficinas con mapa, horarios e indicaciones.
 * Lo abre el badge "Envío Nacional" del acuerdo. Para los pedidos (sin acuerdo) hay otro,
 * más corto: `components/ProvinceDialog`.
 */
const ProvinceDialog = (props: ProvinceDialogProps) => {
  const { open = false, onClose } = props;

  return (
    <Modal open={open} onClose={onClose}>
      {/* Ámbar: la identidad del badge "Envío Nacional" */}
      <ModalHeader icon={<IconTruckDelivery />} tone="warning">
        <ModalTitle>Acuerdos con Envío Nacional</ModalTitle>
        <ModalDescription>
          Se deben entregar en una oficina de <strong>MailBoxes ETC</strong>.{' '}
          <span className={styles.advice}>No se deben embalar</span>
        </ModalDescription>
      </ModalHeader>
      <ModalBody>
        <section className={styles.section}>
          <h3 className={styles.heading}>
            <IconMapPin size={18} aria-hidden="true" /> Oficinas
          </h3>
          <ul className={styles.offices}>
            {OFFICES.map((office) => (
              <li key={office.name} className={styles.office}>
                <strong>{office.name}</strong>
                <a href={office.map} target="_blank" rel="noopener noreferrer">
                  <span>{office.address}</span>
                  <IconExternalLink size={16} aria-hidden="true" />
                </a>
              </li>
            ))}
          </ul>
        </section>

        <section className={styles.section}>
          <h3 className={styles.heading}>
            <IconClock size={18} aria-hidden="true" /> Horarios de atención
          </h3>
          <ul className={styles.list}>
            <li>
              Lunes a viernes: <strong className={styles.open}>9am a 6pm</strong>
            </li>
            <li>
              Sábados: <strong className={styles.open}>9am a 1pm</strong>
            </li>
            <li>
              Domingos y feriados: <span className={styles.closed}>cerrado</span>
            </li>
          </ul>
        </section>

        <section className={styles.section}>
          <h3 className={styles.heading}>
            <IconChecklist size={18} aria-hidden="true" /> Indicaciones de entrega
          </h3>
          <ul className={styles.list}>
            <li>Di en el mostrador: “Buen día, vengo a dejar pedidos de Guvery”.</li>
            <li>Coloca los pedidos sobre el mostrador y toma unas fotos del conjunto.</li>
            <li>Envíalas por tu grupo de WhatsApp de viajero (a Guvery).</li>
            <li>
              Toma 2 fotos de cada Acuerdo y súbelas desde el botón de confirmar la entrega.
            </li>
          </ul>
          <p className={styles.note}>
            Asegúrate de que en la foto se vea claramente el estado del pedido entregado.
          </p>
          <p className={styles.note}>
            Si el pedido es un iPhone, iPad o MacBook, envíanos por el grupo una foto del modelo y
            del número de serie (aparecen en el reverso del empaque).
          </p>
        </section>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>Entendido</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ProvinceDialog;
